import {
  PriorityHigh,
  LowPriority,
  Chat
} from "@mui/icons-material";

export const getPriorityConfig = (priority: string) => {
    const p = priority?.toLowerCase();
    if (p === "high") {
        return {
            color: "error.main",
            icon: <PriorityHigh sx={{ fontSize: 16 }} />,
            label: "High",
        };
    }
    if (p === "medium") {
        return {
            color: "warning.main",
            icon: <PriorityHigh sx={{ fontSize: 16 }} />,
            label: "Medium",
        };
    }
    if (p === "low") {
        return {
            color: "success.main",
            icon: <LowPriority sx={{ fontSize: 16 }} />,
            label: "Low",
        };
    }
    return {
        color: "text.secondary",
        icon: <PriorityHigh sx={{ fontSize: 16 }} />,
        label: 'N/A',
    };
};